<template>
  <div class="body">
    <div class="remove">
      <van-image
        @click="remove"
        :src="require('../../../../../../public/image/13/02/7.png')"
      ></van-image>
    </div>
    <div class="dialogWarp">
      <div class="warp">
        <van-image
          class="headerImage"
          :src="require('../../../../../../public/image/13/04/1.png')"
        ></van-image>

        <div class="jlImage">
          <van-image
            :src="require('../../../../../../public/image/13/04/2.png')"
          ></van-image>
        </div>
        <div class="jdImage">
          <van-image
            :src="require('../../../../../../public/image/13/04/3.png')"
          ></van-image>
        </div>
        <div class="buttonwarp">
          <van-image
            @click="clickme"
            :src="require('../../../../../../public/image/13/04/4.png')"
          ></van-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import getData from '../../../../../../utils/request/request'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import browser from '../../../../../../utils/browser.js'
import getButton from '../../../../../../utils/getButton'

export default {
  props: {
    isActivity: Boolean
  },
  computed: {
    ...mapGetters(['phone', 'gameStatus'])
  },
  created() {
    this.$emit(
      'changeBackgroundImage',
      require('../../../../../../public/image/13/02/1.png')
    )
  },
  data() {
    return {
      browser: browser()
    }
  },
  methods: {
    remove() {
      this.$emit('removeClick', false)
    },
    async send_gift() {
      let Api = {
        url: '/api/send_gift',
        type: 'post'
      }
      let form = {
        phone: this.phone,
        type: 'fbst'
      }
      let res = await getData(this.$http(Api, form))
      if (res.code === 1) {
        this.$emit('getStatus')
        this.$emit('changePage', 5)
      } else {
        switch (res.msg) {
          case '請先完成手機預約':
            this.$emit('showPhoneHandel')
            break
          case '禮包碼已領完':
            this.$emit('showShowCheck')
            break
          default:
            Toast(res.msg)
            break
        }
      }
    },
    async clickme() {
      if (this.isActivity) {
        getButton('預約頁-加入FB社團按鈕-加入按鈕')
      } else {
        getButton('版頭-加入FB社團按鈕-加入按鈕')
      }
      await this.send_gift()
      if (this.browser.iPhone) {
        window.location.href = 'fb://group/?id=455633360270875'
      } else if (this.browser.android) {
        window.open('fb://group/455633360270875')
      } else {
        window.open('https://www.facebook.com/groups/455633360270875')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.body {
  width: 100%;
  padding: 10px;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  .remove {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 15px;
  }
  .dialogWarp {
    position: relative;
    width: 100%;
    height: 100%;
    .warp {
      .headerImage {
        width: 60%;
        display: block;
        margin: 0 auto;
        margin-top: 20px;
      }
      .buttonwarp {
        /deep/ .van-image {
          animation: heartbeat 1s ease infinite;
          display: block;
          width: 60%;
          margin: 0 auto;
          margin-top: 20px;
        }
      }
      .jlImage {
        margin-top: 10px;
      }
      .jdImage {
        margin-top: 10px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/components/faceDialog/page4/index.vue